import { Close as CloseIcon } from "@mui/icons-material";

import EdmIconButton, { EdmIconButtonPropsType } from "./EdmIconButton";

export default function CloseButton(props: EdmIconButtonPropsType) {
  return (
    <EdmIconButton {...props} size="large">
      <CloseIcon />
    </EdmIconButton>
  );
}
